export default "__VITE_ASSET__C70PCcOJ__"